import React, {Component} from 'react';

import {
    Breadcrumb,
    BreadcrumbItem, Col, Row,
} from 'reactstrap';

import s from './Dashboard.module.scss';
import Widget from '../../components/Widget';
import StatusChart from "./charts/StatusChart";
import {Seccionales} from "./objects/seccionales";
import {Banco} from "./objects/banco";
import BankChart from "./charts/BankChart";
import {Lider} from "./objects/lider";
import LeaderChart from "./charts/LeaderChart";


class Dashboard extends Component {
    state = {
        data: [],
        dataBank: [],
        dataLeader: [],
    }

    componentDidMount() {
        this.getSectionalComparative();
        this.getLeaderComparative();
        this.getBankComparative();
    }
    getSectionalComparative() {
        this.API_URL = "/sectionalComparative"
        let fecha = "";
        let BOGOTANORTE = 0;
        let BOGOTASUR = 0;
        let CARIBE = 0;
        let CENTRO = 0;
        let OCCIDENTE = 0;
        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {
                var structure2 = []
                data1.map(item => {
                    if(fecha !== item.fecha){
                        if(fecha !== ""){
                            var Total =  BOGOTANORTE+ BOGOTASUR+ CARIBE + CENTRO + OCCIDENTE;
                            var seccional = new Seccionales(fecha, BOGOTANORTE, BOGOTASUR, CARIBE, CENTRO, OCCIDENTE, Total);
                            structure2.push(seccional)
                        }
                        fecha = item.fecha;
                    }
                    switch (item.regional){
                        case "BOGOTA NORTE":
                            BOGOTANORTE = item.total;
                            break;
                        case "BOGOTA SUR":
                            BOGOTASUR = item.total;
                            break;
                        case "CARIBE":
                            CARIBE = item.total;
                            break;
                        case "CENTRO":
                            CENTRO = item.total;
                            break;
                        case "OCCIDENTE":
                            OCCIDENTE = item.total;
                            break;

                    }
                });
                var Total =  BOGOTANORTE+ BOGOTASUR+ CARIBE + CENTRO + OCCIDENTE;
                var seccional = new Seccionales(fecha, BOGOTANORTE, BOGOTASUR, CARIBE, CENTRO, OCCIDENTE, Total);
                structure2.push(seccional)
                this.setState(() => ({
                    data: structure2
                }));
            });
    }
    getLeaderComparative(){
        this.LEADER_API_URL = "/leaderComparative"
        let fecha = "";
        let AdelaMurcia = 0;
        let CarlosRamirez = 0;
        let DiegoMarquez = 0;
        let DiegoBarreto = 0;
        let JoseGomez = 0;
        fetch(this.LEADER_API_URL)
            .then((res) => res.json())
            .then((data2) => {
                var structure1 = []
                data2.map(item => {
                    if(fecha !== item.fecha){
                        if(fecha != ""){
                            var Total = AdelaMurcia + CarlosRamirez + DiegoMarquez + DiegoBarreto + JoseGomez
                            var lider = new Lider(fecha, AdelaMurcia, CarlosRamirez, DiegoMarquez, DiegoBarreto, JoseGomez, Total);
                            structure1.push(lider)
                        }
                        fecha = item.fecha;

                    }

                    switch (item.lider){
                        case "PATRICIA MURCIA":
                            AdelaMurcia = item.total;
                            break;
                        case "CARLOS RAMIREZ":
                            CarlosRamirez = item.total;
                        case "DIEGO BARRETO":
                            DiegoBarreto = item.total;
                            break;
                        case "DIEGO MARQUEZ":
                            DiegoMarquez = item.total;
                            break;
                        case "JOSE GOMEZ":
                            JoseGomez = item.total;
                            break;
                    }
                });
                var Total = AdelaMurcia + CarlosRamirez + DiegoMarquez + DiegoBarreto + JoseGomez
                var lider = new Lider(fecha, AdelaMurcia, CarlosRamirez, DiegoMarquez, DiegoBarreto, JoseGomez, Total);
                structure1.push(lider)
                this.setState(() => ({
                    dataLeader: structure1
                }));
            });
    }
    getBankComparative() {
        this.BANK_API_URL = "/bankComparative"
        let fecha = "";
        let Bancolombia = 0;
        let Bbva = 0;
        let Davivienda = 0;
        let Otros = 0;
        fetch(this.BANK_API_URL)
            .then((res) => res.json())
            .then((data1) => {
                var structure = []
                data1.map(item => {
                    if(fecha !== item.fecha){
                        if(fecha != ""){
                            var Total = Bancolombia + Bbva + Davivienda + Otros;
                            var banco = new Banco(fecha, Bancolombia, Bbva, Davivienda, Otros, Total);
                            Bancolombia = 0;
                            Bbva = 0;
                            Davivienda = 0;
                            Otros = 0;
                            structure.push(banco);
                        }
                        fecha = item.fecha;

                    }

                    switch (item.banco){
                        case "BANCOLOMBIA":
                            Bancolombia = item.total;
                            break;
                        case "BBVA":
                            Bbva = item.total;
                            break;
                        case "DAVIVIENDA":
                            Davivienda = item.total;
                            break;
                        case "OTROS BANCOS":
                            Otros = item.total;
                            break;
                    }
                });
                var Total = Bancolombia + Bbva + Davivienda + Otros;
                var banco = new Banco(fecha, Bancolombia, Bbva, Davivienda, Otros, Total);
                structure.push(banco);
                this.setState(() => ({
                    dataBank: structure
                }));
            });
    }
  render() {
    return (
      <div className={s.root}>
        <Breadcrumb>
          <BreadcrumbItem> Estas en</BreadcrumbItem>
          <BreadcrumbItem active>Inicio</BreadcrumbItem>
        </Breadcrumb>
        <h2 className="mb-lg">Resumen General</h2>
          <Widget title={<h4> Bancos </h4>} close collapse settings>
              <Row>
                  <Col lg="12" xs="100%">
                      <div className="location-selector">
                          <BankChart data = {this.state.dataBank} />
                      </div>
                  </Col>
              </Row>
          </Widget>
          <Widget title={<h4> Team Leader </h4>} close collapse settings>
              <Row>
                  <Col lg="12" xs="100%">
                      <div className="location-selector">
                          <LeaderChart data = {this.state.dataLeader} />
                      </div>
                  </Col>
              </Row>
          </Widget>
          <Widget title={<h4> Regionales </h4>} close collapse settings>
              <Row>
                  <Col lg="12" xs="100%">
                      <div className="location-selector">
                          <StatusChart data = {this.state.data} />
                      </div>
                  </Col>
              </Row>
          </Widget>
      </div>
    );
  }
}

export default Dashboard;
